export const FORM_CODE_FF011 = 'FF011';

/** Consent read preview: 建災防-様式-ずい道 3.1, 3.2, 4. */
export const HEALTH_INFO_ZUIDO_CONSENT_PAGE_COUNT = 3;

/** Filled preview after agreeing to forms 3.1 and 3.2. */
export const HEALTH_INFO_ZUIDO_FILLED_PREVIEW_PAGE_COUNT = 2;

/** Form 4 — work history confirmation (single page). */
export const HEALTH_INFO_ZUIDO_WORK_HISTORY_FORM_PAGE = 3;

export type HealthInfoZuidoStep =
  | 'intro'
  | 'agreeForm31'
  | 'agreeForm32'
  | 'workHistoryIntro'
  | 'confirmWorkHistory'
  | 'workHistoryCorrection';

export type YesNo = 'yes' | 'no' | null;

export type WorkHistoryCorrectionCategory =
  | 'personalInfo'
  | 'workPeriod'
  | 'workType'
  | 'worksite'
  | 'other';

export interface HealthInfoZuidoFormValues {
  introContinued?: string;
  consentDocumentRead?: string;
  agreeForm31?: YesNo | string;
  agreeForm32?: YesNo | string;
  forms312PreviewDone?: string;
  workHistoryIntroContinued?: string;
  workHistoryFormViewed?: string;
  workHistoryInfoCorrect?: YesNo | string;
  workHistoryCorrectionCategory?: WorkHistoryCorrectionCategory | string;
}
